/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Unit of volumetric flow rate.
 */
export enum VolumetricFlowRateUnit {
    M_S = 'm³/s',
    M_MIN = 'm³/min',
    L_S = 'l/s',
    L_MIN = 'l/min',
}
